import React, { lazy, Suspense } from 'react'
import ReactDOM from 'react-dom/client'
import { ChakraProvider } from '@chakra-ui/react'
import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Provider } from 'react-redux'
import { gsap } from 'gsap'
import { useGSAP } from '@gsap/react'
import { HelmetProvider } from 'react-helmet-async'
import { I18nProvider } from '@lingui/react'

import ErrorPage from './routes/ErrorPage'
import reportWebVitals from './reportWebVitals'
import './index.css'
import theme from './theme/index'
import { i18n } from './i18nRushB'
import store from './store'
import Loading from './components/Loading'

import Root from './routes/RushBApp'
import RushRouters from './router'

const PrivacyPolicy = lazy(() => import('./routes/pages/PrivacyPolicy'))
const TermsOfService = lazy(() => import('./routes/pages/TermsOfService'))

gsap.registerPlugin(useGSAP)

// Create a client
const queryClient = new QueryClient()

const router = createBrowserRouter([
  {
    path: '/',
    element: <Navigate to="/zh" replace />,
  },
  {
    path: '/:lang',
    element: <Root />,
    errorElement: <ErrorPage />,
    children: [
      ...RushRouters,
      {
        path: 'privacy-policy',
        element: (
          <Suspense fallback={<Loading />}>
            <PrivacyPolicy />
          </Suspense>
        ),
      },
      {
        path: 'terms-of-service',
        element: (
          <Suspense fallback={<Loading />}>
            <TermsOfService />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: '*',
    element: <Navigate to="/zh" replace />,
  },
])

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <I18nProvider i18n={i18n}>
      <ChakraProvider theme={theme}>
        <QueryClientProvider client={queryClient}>
          <Provider store={store}>
            <HelmetProvider>
              <RouterProvider router={router} />
            </HelmetProvider>
          </Provider>
        </QueryClientProvider>
      </ChakraProvider>
    </I18nProvider>
  </React.StrictMode>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
